import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d16397a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-cards" }
const _hoisted_2 = { class: "main-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainheaderComponent = _resolveComponent("MainheaderComponent")!
  const _component_MainCardPreloadComponent = _resolveComponent("MainCardPreloadComponent")!
  const _component_MainCardComponent = _resolveComponent("MainCardComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainheaderComponent, { title: "Топ недели по просмотрам" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (row) => {
        return _withDirectives(_createVNode(_component_MainCardPreloadComponent, null, null, 512), [
          [_vShow, _ctx.preloaders.topViewWeekMods]
        ])
      }), 64)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topViewWeekMods, (row) => {
        return _withDirectives((_openBlock(), _createBlock(_component_MainCardComponent, { data: row }, {
          "tr-badge": _withCtx(() => [
            _createTextVNode(" Топ просмотров ")
          ]),
          _: 2
        }, 1032, ["data"])), [
          [_vShow, !_ctx.preloaders.topViewWeekMods]
        ])
      }), 256))
    ]),
    _createVNode(_component_MainheaderComponent, { title: "Топ недели по скачиваниям" }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (row) => {
        return _withDirectives(_createVNode(_component_MainCardPreloadComponent, null, null, 512), [
          [_vShow, _ctx.preloaders.topDownloadsWeekMods]
        ])
      }), 64)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topDownloadsWeekMods, (row) => {
        return _withDirectives((_openBlock(), _createBlock(_component_MainCardComponent, { data: row }, {
          "tr-badge": _withCtx(() => [
            _createTextVNode(" Топ скачиваний ")
          ]),
          _: 2
        }, 1032, ["data"])), [
          [_vShow, !_ctx.preloaders.topDownloadsWeekMods]
        ])
      }), 256))
    ])
  ], 64))
}